var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 169,
    viewBox: "0 0 310 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.9688 118.118H163.069",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6953 126.13H97.9375",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.953 168H293.331",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.258 15.5098L282.993 15.5098",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.997 8.79004H309.097",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6182 62.5488H85.5315",
    stroke: "#F4F4F4",
    strokeWidth: 1.03133,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.7007,
    y: 27.397,
    width: 5.21456,
    height: 137.71,
    rx: 2.60728,
    transform: "rotate(-7.05387 90.7007 27.397)",
    fill: "#307FE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96.356,
    y: 30.6382,
    width: 122.343,
    height: 75.2014,
    transform: "rotate(-7.05387 96.356 30.6382)",
    fill: "#FFBE9F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161.682,
    cy: 60.4419,
    r: 22.6845,
    transform: "rotate(-7.05387 161.682 60.4419)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.819 62.2188L161.886 70.6217L180.957 44.2288",
    stroke: "#307FE2",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.042 93.563L285.952 112.689",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.635 99.3848L274.36 106.865",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.395 94.5522L278.601 111.698",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M292.546 107.075L274.448 99.1763",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1748 135.95L26.0756 148.021",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8589 139.625L33.3922 144.345",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5347 136.576L30.7157 147.397",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9146 144.479L33.3361 139.493",
    stroke: "#AFA5EF",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.134 149.648C223.489 164.168 207.949 145.272 215.331 133.117C220.646 124.365 228.4 133.117 220.042 138.964C209.586 146.279 199.33 136.598 201.308 125.33",
    stroke: "#83B2EE",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M297.221 50.6589C294.58 77.9387 270.063 70.2728 266.042 60.0915C262.245 50.4758 271.743 44.8372 275.557 54.9376C279.371 65.038 260.884 77.5018 249.818 66.7801",
    stroke: "#83B2EE",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34754 19.3024C-1.77517 46.3979 23.8732 44.9725 30.2655 36.0865C36.3027 27.6941 28.4755 19.9003 22.3031 28.7585C16.1306 37.6166 31.0007 54.23 44.3561 46.5461",
    stroke: "#83B2EE",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.809 33.5527L271.836 2.77046",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8301 104.811L22.7933 121.4",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M265.418 30.2012L292.241 11.9151",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6491 99.6116L8.51131 104.194",
    stroke: "#FCBB26",
    strokeWidth: 2.06267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSuccess);
export default __webpack_public_path__ + "static/media/flag_success.8694bfe3dc4b8dac71fb93120689a145.svg";
export { ForwardRef as ReactComponent };